import type { ReactNode } from 'react';

/** Shared inset and surface for groups of related form controls. */
export function FormPanel({
  children,
  className = '',
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={`bo-card p-4 ${className}`.trim()}>{children}</div>;
}
